import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAnalyticsModule, APP_NAME, APP_VERSION } from '@angular/fire/compat/analytics';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card'
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import { MatNativeDatetimeModule } from '@mat-datetimepicker/core';
import * as Sentry from '@sentry/angular-ivy';
import { ToastrModule } from 'ngx-toastr';
import { versions } from 'projects/versions';
import { PipeModule } from 'projects/webapp/app/modules/pipe/pipe.module';
import { InquiryStep21Component } from 'projects/webapp/app/pages/public/inquiry/raw/step2.1/step2.1.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from './environments/environment.prod';
import { AppVersionInterceptor } from './interceptors/app-version/app-version.interceptor';
import { AuthInterceptor } from './interceptors/auth/auth.interceptor';
import { ErrorInterceptor } from './interceptors/error/error.interceptor';
import { RefreshTokenInterceptor } from './interceptors/refresh-token/refresh-token.interceptor';
import { CaptchaModule } from './modules/captcha/captcha.module';
import { PublicInquiryComponent } from './pages/public/inquiry/public-inquiry/public-inquiry.component';
import { InquiryHeaderComponent } from './pages/public/inquiry/raw/inquiry-header/inquiry-header.component';
import { InquirySidebarComponent } from './pages/public/inquiry/raw/inquiry-sidebar/inquiry-sidebar.component';
import { InquiryStepNavComponent } from './pages/public/inquiry/raw/inquiry-step-nav/inquiry-step-nav.component';
import { InquiryStep1Component } from './pages/public/inquiry/raw/step1/step1.component';
import { InquiryStep2Component } from './pages/public/inquiry/raw/step2/step2.component';
import { InquiryStep25Component } from './pages/public/inquiry/raw/step2.5/step2.5.component';
import { InquiryStep35Component } from './pages/public/inquiry/raw/step3.5/step3.5.component';
import { InquiryStep3Component } from './pages/public/inquiry/raw/step3/step3.component';
import { InquiryStep4Component } from './pages/public/inquiry/raw/step4/step4.component';
import { InquirySummaryComponent } from './pages/public/inquiry/raw/step_summary/step_summary.component';
import { GooglePlacesAutocompleteComponent } from './standalones/google-places-autocomplete/google-places-autocomplete.component';
import { IconComponent } from './standalones/icon/icon.component';
import { RecaptchaAttributionComponent } from './standalones/recaptcha-attribution/recaptcha-attribution.component';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@NgModule({
  declarations: [
    AppComponent,
    InquirySummaryComponent,
    InquiryStep1Component,
    InquiryStep2Component,
    InquiryStep21Component,
    InquiryStep25Component,
    InquiryStep3Component,
    InquiryStep35Component,
    InquiryStep4Component,
    PublicInquiryComponent,
    InquiryHeaderComponent,
    InquirySidebarComponent,
    InquiryStepNavComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAnalyticsModule,
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatNativeDateModule,
    MatCheckboxModule,
    CaptchaModule,
    AppRoutingModule,
    ToastrModule.forRoot(),
    MatNativeDatetimeModule,
    // ServiceWorkerModule.register('ngsw-worker.js', {
    //   enabled: environment.production,
    //   // Register the ServiceWorker as soon as the app is stable
    //   // or after 30 seconds (whichever comes first).
    //   registrationStrategy: 'registerWhenStable:10000',
    // })
    PipeModule,
    GooglePlacesAutocompleteComponent,
    IconComponent,
    RecaptchaAttributionComponent,
  ],
  providers: [
    DatePipe,
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'de-CH' },
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false, }) },
    { provide: Sentry.TraceService, deps: [Router] },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {
      },
      deps: [Sentry.TraceService],
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RefreshTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AppVersionInterceptor, multi: true },
    { provide: APP_NAME, useValue: 'webapp' },
    { provide: APP_VERSION, useValue: versions.hash },
    provideHttpClient(withInterceptorsFromDi()),
  ]
})
export class AppModule {
}
